<template>
    <div
        class="input-table"
        v-if="items.length"
    >
        <div
            class="input-table-shadow"
            v-for="(traveler, index) in items"
            :key="index"
        >
            <div class="d-flex row align-items-center">
                <div class="col-4 border-right">
                    <input class="pl-3" type="text" readonly="readonly" :value="travelerInfo(traveler)" />
                </div>
                <div class="col-4 border-right">
                    <reservation-details-travelers-placement
                        :traveler="traveler"
                        :selectedValue="getTravelerTransportType(traveler)"
                        :placements="placements"
                        @selected="setTravelerTransportType"
                    ></reservation-details-travelers-placement>
                </div>
                <div class="col-4">
                    <reservation-details-travelers-coupe
                        :key="coupesKey + getTravelerTransportType(traveler)"
                        :traveler="traveler"
                        :selectedValue="getTravelerCoupe(traveler)"
                        :coupes="getSelectedPlacementCoupe(traveler)"
                        @selected="setTravelerCoupe"
                    ></reservation-details-travelers-coupe>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Reservation from '@/services/hatsApi/Reservation'
export default {
  props: {
    travelers: {
      type: Array,
      required: true
    },
    rollingStockId: {
      type: Number | String,
      required: true
    },
    serviceId: {
      type: String | Number,
      required: true
    },
    reservationLineId: {
      type: String | Number,
      required: false
    },
    placements: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      items: this.travelers,
      noneLabel: '- none -',
      coupes: [],
      coupesKey: 0
    }
  },
  async created () {
    if (this.placements.length) {
      try {
        let filters = [
          {
            property: 'rollingStockId',
            value: this.rollingStockId
          }
        ]
        if (this.reservationLineId > 0) {
          filters.push({
            property: 'reservationLineId',
            value: this.reservationLineId
          })
        }
        const rollingStockCoupes = await Reservation.getRollingStockCoupes(filters)
        if (rollingStockCoupes.data.success) {
          this.coupes = rollingStockCoupes.data.data
          this.reloadCoupesKey()
        }
      } catch (e) {
        console.log(e)
      }
    }
  },
  methods: {
    reloadCoupesKey () {
      this.coupesKey += 1
    },
    getTravelerTransportType (traveler) {
      let rollingStock = this.$_.find(traveler.placements, {'rollingStockId': parseInt(this.rollingStockId)})
      if (rollingStock) {
        let placement = this.$_.find(rollingStock.rollingStockCoupes, {'serviceId': parseInt(this.serviceId)})
        if (placement) {
          return placement.transportTypeId
        }
      }
      return null
    },
    setTravelerTransportType (val, traveler) {
      if (!parseInt(val)) {
        return
      }
      let placement = {
        serviceId: parseInt(this.serviceId),
        transportTypeId: parseInt(val)
      }
      let index = this.$_.findIndex(traveler.placements, {'rollingStockId': parseInt(this.rollingStockId)})
      if (index !== -1) {
        let serviceIndex = this.$_.findIndex(traveler.placements[index].rollingStockCoupes, {'serviceId': parseInt(this.serviceId)})
        if (serviceIndex !== -1) {
          traveler.placements[index].rollingStockCoupes.splice(serviceIndex, 1, placement)
        } else {
          traveler.placements[index].rollingStockCoupes.splice(0, 1, placement)
        }
      } else {
        traveler.placements.push({
          rollingStockId: parseInt(this.rollingStockId),
          rollingStockCoupes: [placement]
        })
      }
    },
    getTravelerCoupe (traveler) {
      let rollingStock = this.$_.find(traveler.placements, {'rollingStockId': parseInt(this.rollingStockId)})
      if (rollingStock) {
        let placement = this.$_.find(rollingStock.rollingStockCoupes, {'serviceId': parseInt(this.serviceId)})
        if (placement) {
          return placement.rollingStockSeatId
        }
      }
      return null
    },
    setTravelerCoupe (val, traveler) {
      if (!val) {
        return
      }
      let index = this.$_.findIndex(traveler.placements, {'rollingStockId': parseInt(this.rollingStockId)})
      if (index !== -1) {
        let serviceIndex = this.$_.findIndex(traveler.placements[index].rollingStockCoupes, {'serviceId': parseInt(this.serviceId)})
        if (serviceIndex !== -1) {
          this.$set(traveler.placements[index].rollingStockCoupes[serviceIndex], 'rollingStockCoupeId', parseInt(val.id))
          this.$set(traveler.placements[index].rollingStockCoupes[serviceIndex], 'rollingStockSeatId', parseInt(val.itemId))
          this.$emit('seatsChosen')
        }
      } else {
        console.log('No rolling stock chosen')
      }
    },
    getSelectedPlacementCoupe (traveler) {
      if (!this.coupes) {
        console.log('leeg')
        return
      }
      let transportTypeId = this.getTravelerTransportType(traveler)
      let coupes = []
      if (transportTypeId !== this.noneLabel) {
        this.coupes.forEach((coupe) => {
          if (parseInt(coupe.available) > 0 && parseInt(coupe.serviceId) === parseInt(transportTypeId)) {
            let group = {
              name: coupe.wagon + ' | ' + coupe.name,
              items: []
            }
            coupe.seats.forEach((seat) => {
              let item = {
                id: coupe.id,
                serviceId: parseInt(coupe.serviceId),
                itemId: parseInt(seat.id),
                name: seat.name,
                wagon: coupe.wagon
              }
              group.items.push(item)
            })
            coupes.push(group)
          }
        })
      }
      return coupes
    },
    travelerInfo (traveler) {
      let firstName = traveler.first_name || 'John'
      let lastName = traveler.last_name || 'Doe'
      let birthDate = traveler.birthdate || ''
      return firstName + ' ' + lastName + ' ' + birthDate
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/reservation/details/TransportTravelers.vue